var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"default relative flex min-h-screen flex-col"},[_c('Nuxt',{staticClass:"flex-grow bg-worky-white"}),_vm._v(" "),_c('ToastComponent'),_vm._v(" "),_c('WidgetButton')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }